module.exports = __webpack_public_path__ + "media/images/micael_welcome-3d57d2fa69a8eff17f1a897575ab736b.png";